import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PaymentCustomerService } from '../../../providers/payment-customer.service';
import { Braintree_customer } from '../../../models/accounting/banking/braintree_customer';
import { Braintree_credit_card } from '../../../models/accounting/banking/braintree_credit_card';
import { ModalAddCreditCardComponent } from '../modal-add-credit-card/modal-add-credit-card.component';
import { faCreditCard, faPlus,  faDotCircle } from '@fortawesome/pro-regular-svg-icons';
import { faCcVisa, faCcAmex, faCcDiscover, faCcMastercard } from '@fortawesome/free-brands-svg-icons';

@Component({
  standalone: false,
  selector: 'app-braintree-choose-payment-method',
  templateUrl: './braintree-choose-payment-method.component.html',
styleUrls:  ['./braintree-choose-payment-method.component.css']
})
export class BraintreeChoosePaymentMethodComponent implements OnInit {

	faCreditCard = faCreditCard;
	faPlus = faPlus;
	faDotCircle = faDotCircle;
	faCcVisa = faCcVisa;
  faCcAmex = faCcAmex;
  faCcDiscover = faCcDiscover;
  faCcMastercard = faCcMastercard;

	customers: Braintree_customer[] = [];

	@Output() payment_method_selected$: EventEmitter<Braintree_credit_card> =  new EventEmitter<Braintree_credit_card>();
	@Output() error$: EventEmitter<string> = new EventEmitter<string>();

  constructor(private modal: NgbModal, private paymentCustomerService: PaymentCustomerService) { }

  ngOnInit(): void {
  	this.paymentCustomerService.get_list().then(customer_list => {
		this.customers = customer_list;
	}).catch(error => {
		this.error$.emit(error);
	});
  }

 onSelectCard(card: Braintree_credit_card){
  	this.payment_method_selected$.emit(card);
  }

  addPaymentMethod(){
    let modal_ref_payment = this.modal.open(ModalAddCreditCardComponent, { size: 'lg'});
    modal_ref_payment.componentInstance.card_added$.subscribe((card: Braintree_credit_card) => {

      //Does customer exist?
      let selected_customer: Braintree_customer = null;
      this.customers.forEach((customer, i) => {
        if(card.system_customer_id == customer.system_customer_id){
          selected_customer = customer;
        }
      });

      if(selected_customer == null) {
        selected_customer = modal_ref_payment.componentInstance.selected_customer;
        this.customers.push(selected_customer);

        this.customers.sort( function(a_customer, b_customer) {
            if((a_customer.last_name + a_customer.first_name) < (b_customer.last_name + b_customer.first_name)){
                return -1;
            } else if((a_customer.last_name + a_customer.first_name) > (b_customer.last_name + b_customer.first_name)){
                return 1;
            } else {
                return 0;
            }
        });

      }


      selected_customer.credit_card_list.push(card);

      selected_customer.credit_card_list.sort( function(credit_card_a, credit_card_b) {
        if(credit_card_a.masked_number < credit_card_b.masked_number){
          return -1;
        } else if(credit_card_a.masked_number > credit_card_b.masked_number){
          return 1;
        } else {
          return 0;
        }
      });

      //Indicate selected in view too
      card.selected = true;

      this.payment_method_selected$.emit(card);

      modal_ref_payment.close();

    }, error =>{
      this.error$.emit(error);
    });

  }

}
